export default __webpack_public_path__ + "static/media/widget-close-cross.f5f92e8f.svg";